import { Injectable } from '@angular/core';
import { Converter, Product } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class CustomProductDataSheetConverter implements Converter<Product, Product> {
  convert(source: Product, target?: Product): Product {
    if (target === undefined) {
      // eslint-disable-next-line no-param-reassign
      target = { ...(source as any) } as Product;
    }
    if (source.dataSheets) {
      // eslint-disable-next-line no-param-reassign
      target.dataSheets = source.dataSheets.map((dataSheet) => ({
        ...dataSheet,
        ...this.spreadMetadata(dataSheet?.metadata?.entry),
        select: false,
      }));
    }
    return target;
  }

  spreadMetadata(entries: { key: string; value: string }[]) {
    const metadataObject: { [k: string]: string } = {};

    if (entries) {
      // eslint-disable-next-line no-return-assign
      entries.forEach(({ key, value }) => {
        metadataObject[key] = value;
      });
    }
    return metadataObject;
  }
}
